export default {
  methods: {
    customFilter: config => {
      config.options.splice(0, 0, "empty");
      const filterOptions = config.options.map(val => {
        if (typeof val === "object") {
          return {
            displayKey: val.key,
            displayName: val.value,
            test: function(filterValue, cellValue) {
              return (
                cellValue.toString().toLowerCase() ===
                val.key.toString().toLowerCase()
              );
            },
            hideFilterInput: true
          };
        } else {
          if (val.toLowerCase() === "empty") return "empty";
          return {
            displayKey: val,
            displayName: val,
            test: function(filterValue, cellValue) {
              return cellValue.toLowerCase() === val.toLowerCase();
            },
            hideFilterInput: true
          };
        }
      });

      return {
        filterOptions: filterOptions,
        suppressAndOrCondition:
          config.suppressAndOrCondition === false ? false : true,
        closeOnApply: true,
        buttons: ["apply", "reset"]
      };
    }
  }
};
